export const pageParents = {
  '/appeals': '/appeal/',
  '/orders': '/order/',
  '/hr': '/hr/',
  '/hr-employees': '/hr-employees/',
  '/hr/feedback-funnel': '/hr/feedback-funnel',
  '/claims': '/claim/',
  '/claims-requests': '/claim-request/',
  '/logistics/deliveries': '/logistics/deliveries/',
  '/new/organizations': ['/new/organization/', '/offices/', '/office/', '/employees_new/'],
  '/admin/enum-collections': '/admin/enum-collection/',
  '/admin/roles': '/admin/role/',
  '/call-center/new-clients': '/client-new/',
  '/montage': '/montage/',
  '/measurements': '/measurements/',
}
